(function() {
  var STORAGE_KEY = 'hitowan_scroll_pos';
  var PAGE_KEY = 'hitowan_scroll_page';

  // ページを離れる前にスクロール位置を保存
  window.addEventListener('pagehide', function() {
    sessionStorage.setItem(STORAGE_KEY, window.scrollY);
    sessionStorage.setItem(PAGE_KEY, location.pathname);
  });

  // DOMが読み込まれたらスクロール位置を復元
  document.addEventListener('DOMContentLoaded', function() {
    var savedPage = sessionStorage.getItem(PAGE_KEY);
    var savedPos = sessionStorage.getItem(STORAGE_KEY);

    // 同じページに戻ってきた場合のみ復元
    if (savedPage === location.pathname && savedPos) {
      var restoreCancelled = false;
      var cancelRestore = function() {
        restoreCancelled = true;
      };
      // ユーザーが自分でクリック・スクロールなど操作したら復元を中止する
      // （店舗一覧ナビなど、ページ内リンクのスクロールを復元処理が上書きしてしまうのを防ぐ）
      ['click', 'wheel', 'touchstart', 'keydown'].forEach(function(evt) {
        window.addEventListener(evt, cancelRestore, { once: true, passive: true });
      });

      // 画像など読み込み完了後にスクロール
      window.addEventListener('load', function() {
        setTimeout(function() {
          if (!restoreCancelled) {
            window.scrollTo(0, parseInt(savedPos, 10));
          }
        }, 100);
      });
    }

    // 保存データをクリア（1回だけ復元）
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(PAGE_KEY);
  });
})();
